/* M2L Digital Studios - native Shopify cart (AJAX Cart API + Section Rendering API).
   No custom cart/checkout logic: all mutations go through Shopify's own
   /cart/add.js and /cart/change.js endpoints, and the drawer markup is always
   re-rendered server-side via ?section_id=m2l-cart-drawer. */
(function(){
  var routes = window.M2L_ROUTES || {
    cartAddUrl: '/cart/add.js',
    cartChangeUrl: '/cart/change.js',
    cartUrl: '/cart'
  };
  var drawerSectionId = 'm2l-cart-drawer';

  function qs(sel, ctx){ return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function getDrawer(){ return qs('#m2lCartDrawer'); }
  function getOverlay(){ return qs('#m2lCartOverlay'); }

  function openDrawer(){
    var drawer = getDrawer(), overlay = getOverlay();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(){
    var drawer = getDrawer(), overlay = getOverlay();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function setCartCount(count){
    qsa('.m2l-cart-count').forEach(function(el){
      el.textContent = count;
      el.classList.toggle('is-visible', parseInt(count, 10) > 0);
    });
  }

  function bindDrawerEvents(){
    var drawer = getDrawer();
    if (!drawer) return;

    qsa('[data-cart-close]', drawer).forEach(function(btn){
      btn.addEventListener('click', closeDrawer);
    });

    qsa('[data-cart-remove]', drawer).forEach(function(btn){
      btn.addEventListener('click', function(){
        changeLine(parseInt(btn.getAttribute('data-line'), 10), 0);
      });
    });
  }

  function refreshDrawer(){
    return fetch(routes.cartUrl + '?section_id=' + drawerSectionId)
      .then(function(res){ return res.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('m2lCartDrawer');
        var current = getDrawer();
        if (newDrawer && current){
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = newDrawer.innerHTML;
          current.classList.toggle('is-open', wasOpen);
          setCartCount(newDrawer.getAttribute('data-cart-count') || 0);
          bindDrawerEvents();
        }
      });
  }

  function changeLine(line, quantity){
    var drawer = getDrawer();
    if (drawer) drawer.classList.add('is-loading');
    fetch(routes.cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function(){ return refreshDrawer(); })
      .then(function(){ if (drawer) drawer.classList.remove('is-loading'); });
  }

  function addToCart(form){
    var submitBtn = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('.product-form-error');
    var labelEl = submitBtn ? submitBtn.querySelector('.btn-add-to-cart-label') : null;
    var originalLabel = labelEl ? labelEl.textContent : '';

    if (errorEl) errorEl.textContent = '';
    if (submitBtn){ submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }

    fetch(routes.cartAddUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function(res){
        return res.json().then(function(data){ return { ok: res.ok, data: data }; });
      })
      .then(function(result){
        if (!result.ok){
          throw new Error(result.data && result.data.description ? result.data.description : 'This item could not be added to your cart.');
        }
        return refreshDrawer().then(function(){
          if (labelEl) labelEl.textContent = 'Added ✓';
          openDrawer();
        });
      })
      .catch(function(err){
        if (errorEl) errorEl.textContent = err.message;
      })
      .then(function(){
        if (submitBtn){ submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
        if (labelEl) setTimeout(function(){ labelEl.textContent = originalLabel; }, 1800);
      });
  }

  document.addEventListener('DOMContentLoaded', function(){
    var toggle = qs('#m2lCartToggle');
    if (toggle) toggle.addEventListener('click', openDrawer);

    var overlay = getOverlay();
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeDrawer();
    });

    bindDrawerEvents();

    document.addEventListener('submit', function(e){
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });
  });

  window.M2LCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };
})();
